var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orderComp"},[_c('nav-local-comp',{attrs:{"all":'Заказы',"id":_vm.id,"toAll":_vm.toAll}}),_c('tabs-comp',{attrs:{"moduleName":_vm.moduleName}}),(_vm.tabs.order.active)?_c('order-one-comp'):_vm._e(),(_vm.tabs.user.active)?_c('user-one-comp',{attrs:{"params":{id: _vm.userId},"showOrders":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }